(function() {
    'use strict';

    angular.module('notes', [
            'ui.router',
            'notes.services',
            'notes.constants'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'newsPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, newsPermissionsConst) {}
})();
